import React from "react";
import styles from "./Loader.module.css";

export default function Loader({ size = 40, fullscreen = false }) {
  return (
    <div className={`${styles.loaderOuter} ${fullscreen && styles.fullScreen}`}>
      <div
        className={styles.loader}
        style={{
          width: `${size}px`,
          height: `${size}px`,
          borderWidth: `${size / 10}px`,
        }}
      ></div>
    </div>
  );
}
